import cn from 'classnames';
import styles from "./ProgressBar.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressBar = props => {
  const {
    completed,
    total,
    variant = 'steps'
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.progressBar, styles[variant + 'Variant']),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.progressThumb,
      style: {
        width: 100 * completed / total + '%'
      }
    })
  });
};